"use client";

import { Divider as HeroDivider } from "@heroui/react";
import { cn } from "../../lib/utils";

export const Divider = ({ className, ...props }: { className?: string } & React.ComponentProps<typeof HeroDivider>) => {
  return <HeroDivider className={cn("bg-border-divider-neutral-usual", className)} {...props} />;
};
